import { API, authClient } from '../index'
import { uploadSingleFile } from "../files";

// Get all news
export const getAllNews = () => {
    return authClient().get(`${API}/news/?getDisabled=true`)
}

// Get news by id
export const getNewsById = (id) => {
    return authClient().get(`${API}/news/${id}`)
}

// Create news
export const postNews = async (news, logo) => {
    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        news.logoURL = response?.data?.fileURL;
    }

    return authClient().post(`${API}/news/`, news)
}

// Update text
export const updateNews = async (id, news, logo) => {
    if (logo) {
        const response = await uploadSingleFile(logo, "logos");
        news.logoURL = response?.data?.fileURL;
    }
    return authClient().put(`${API}/news/${id}`, news)
}
// Change status news
export const changeStatusNewsStatus = async (id, active) => {
    return authClient().put(`${API}/news/change-status/${id}`, { active });
};

// Delete news
export const deleteNews = (id) => {
    return authClient().delete(`${API}/news/${id}`)
}